export default __webpack_public_path__ + "static/media/follow.790b1304.svg";